import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.e6p_1 = id;
        this.f6p_1 = name;
        this.g6p_1 = email;
        this.h6p_1 = badge;
        this.i6p_1 = callSignAdjective;
        this.j6p_1 = callSignNoun;
        this.k6p_1 = imageURL;
        this.l6p_1 = avatarType;
        this.m6p_1 = unvalidatedEmails;
        this.n6p_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.e6p_1.toString() + ', name=' + this.f6p_1 + ', email=' + this.g6p_1 + ', badge=' + toString(this.h6p_1) + ', callSignAdjective=' + this.i6p_1 + ', callSignNoun=' + this.j6p_1 + ', imageURL=' + toString(this.k6p_1) + ', avatarType=' + toString(this.l6p_1) + ', unvalidatedEmails=' + toString(this.m6p_1) + ', pins=' + toString(this.n6p_1) + ')';
      }
      hashCode() {
        var result = this.e6p_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.f6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g6p_1) | 0;
        result = imul(result, 31) + hashCode(this.h6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j6p_1) | 0;
        result = imul(result, 31) + hashCode(this.k6p_1) | 0;
        result = imul(result, 31) + hashCode(this.l6p_1) | 0;
        result = imul(result, 31) + hashCode(this.m6p_1) | 0;
        result = imul(result, 31) + hashCode(this.n6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.e6p_1.equals(other.e6p_1))
          return false;
        if (!(this.f6p_1 === other.f6p_1))
          return false;
        if (!(this.g6p_1 === other.g6p_1))
          return false;
        if (!equals(this.h6p_1, other.h6p_1))
          return false;
        if (!(this.i6p_1 === other.i6p_1))
          return false;
        if (!(this.j6p_1 === other.j6p_1))
          return false;
        if (!equals(this.k6p_1, other.k6p_1))
          return false;
        if (!equals(this.l6p_1, other.l6p_1))
          return false;
        if (!equals(this.m6p_1, other.m6p_1))
          return false;
        if (!equals(this.n6p_1, other.n6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
